const getParam = (key: string) => {
    const value = new URLSearchParams(window.location.search).get(key);
    return value ? { [key]: value } : {};
};

const enhanceUrlWithSearchParams = (url: string): string => {
    if (url.includes('https://')) {
        return url;
    }

    let params: Record<string, string> = {};

    const locationParams = ['lat', 'long', 'locationName', 'distance']
        .map(getParam)
        .filter(Boolean)
        .reduce((acc, param) => ({ ...acc, ...param }), {});

    params = { ...params, ...locationParams };

    const productAttributes = new URLSearchParams(window.location.search).get('productAttributes');
    const priceMin = new URLSearchParams(window.location.search).get('priceMin');
    const priceMax = new URLSearchParams(window.location.search).get('priceMax');

    params = {
        ...params,
        ...(priceMin ? { priceMin } : {}),
        ...(priceMax ? { priceMax } : {}),
    };

    if (productAttributes) {
        const attributeMatch = /anzahlTeilnehmer([^,]*)/.exec(productAttributes);
        if (attributeMatch) {
            const values = decodeURIComponent(attributeMatch[1]);
            params = {
                ...params,
                ...(values ? { productAttributes: `anzahlTeilnehmer${values}` } : {}),
            };
        }
    }

    const urlParams =
        Object.keys(params).length > 0 ? `?${new URLSearchParams(params).toString()}` : '';

    return `${url}${urlParams}`;
};

export { enhanceUrlWithSearchParams };
